import React from 'react';
import NumberBlocks from './NumberBlocks';
import { useGameState } from './GameEngine';
import { ScoreBar, ResultBanner, ChoicesGrid, UnlockModal } from './GameUI';

export default function Game1({ onUnlock, unlockedLevel, currentLevel, onNav }) {
  const [showUnlock, setShowUnlock] = React.useState(false);

  const game = useGameState(() => setShowUnlock(true));

  return (
    <div className={`game-screen ${game.celebrating ? 'celebrate' : ''}`}>
      <ScoreBar
        score={game.score}
        total={game.total}
        streak={game.streak}
        correctInRow={game.correctInRow}
        levelName="🔵 Niveau 1 – Cercles"
      />

      {unlockedLevel > 1 && (
        <div className="nav-bar">
          {[1,2,3].filter(l => l <= unlockedLevel).map(l => (
            <button key={l} className={`nav-btn ${currentLevel === l ? 'active' : ''}`} onClick={() => onNav(l)}>
              {l === 1 ? '🔵 Cercles' : l === 2 ? '🟥 Barres' : '🔢 Chiffres'}
            </button>
          ))}
        </div>
      )}

      <div className="problem-card">
        <div className="instruction">Compte les cercles, puis additionne-les !</div>
        <div className="equation-row">
          <div className="number-section">
            <NumberBlocks value={game.numA} tenColor="#FF6B6B" oneColor="#FF9F43" />
          </div>
          <div className="plus-sign">+</div>
          <div className="number-section">
            <NumberBlocks value={game.numB} tenColor="#A29BFE" oneColor="#74B9FF" />
          </div>
          <div className="equals-sign">=</div>
          <div className="question-mark">?</div>
        </div>
        <div className="legend">
          <div className="legend-item">
            <div className="legend-dot" style={{ background: '#FF6B6B' }} />
            <span>= 10</span>
          </div>
          <div className="legend-sep">•</div>
          <div className="legend-item">
            <div className="legend-dot" style={{ background: '#FF9F43' }} />
            <span>= 1</span>
          </div>
        </div>
      </div>

      <ResultBanner showResult={game.showResult} isCorrect={game.isCorrect} numA={game.numA} numB={game.numB} correct={game.correct} />
      <ChoicesGrid choices={game.choices} selected={game.selected} correct={game.correct} onChoice={game.handleChoice} />

      {showUnlock && (
        <UnlockModal
          hasNext={true}
          onNext={() => { setShowUnlock(false); onUnlock(2); }}
        />
      )}
    </div>
  );
}
